module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('em', [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('em', [_vm._v("Clann Meic-bethad")]), _vm._v(" or Clan MacBeth was an outstanding example in Scotland of a kindred pursuing a profession on an hereditary basis. Members of the kindred were to be found practising medicine in the classical Gaelic tradition in various parts of Scotland from the early fourteenth to the early eighteenth century. As such they belonged to the professional learned orders that were so distinctive a feature of the kinbased society in Scotland and Ireland. More medieval Gaelic manuscripts known to have been in their possession have survived than for any other professional kindred in Scotland. One of the purposes of this study is to identify more securely individual members of the kindred associated with these manuscripts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their identification in the surviving records is aided by the fact that their kindred surname was not only distinctive but almost certainly confined to them alone. It contains the rare forename "), _c('em', [_vm._v("Mac-bethad")]), _vm._v(" whose last recorded use as such in Scotland dates to c.1300."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" Its literal meaning is ‘son of life’ and it is therefore probably not fortuitous that it became and remained part of the surname of an hereditary kindred of physicians."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" Originally in the form of "), _c('em', [_vm._v("MacMeic-bethad")]), _vm._v(", "), _c('em', [_vm._v("meic")]), _vm._v(", genitive of "), _c('em', [_vm._v("mac")]), _vm._v(", was eventually discarded, bringing it into line with other surnames in "), _c('em', [_vm._v("mac")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "rfn3"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" By the sixteenth century it was usually written "), _c('em', [_vm._v("MacBethadh")]), _vm._v(" or "), _c('em', [_vm._v("MacBeatha")]), _vm._v(" in Gaelic and most commonly "), _c('em', [_vm._v("MacBeth")]), _vm._v(" or "), _c('em', [_vm._v("MacBeath")]), _vm._v(" in its Scoticised form but with many other variants such as "), _c('em', [_vm._v("MacBay")]), _vm._v(", "), _c('em', [_vm._v("MacBey")]), _vm._v(", "), _c('em', [_vm._v("MacVay")]), _vm._v(", "), _c('em', [_vm._v("MacVia")]), _vm._v(", or "), _c('em', [_vm._v("MacVeagh")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "rfn4"
    }
  }, [_c('sup', [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Individual members of the kindred might also use on occasion surnames specifically associated with their profession; "), _c('em', [_vm._v("Leich")]), _vm._v(" in Scots, and in Gaelic "), _c('em', [_vm._v("Mac "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("an leagha,")]), _vm._v(" later "), _c('em', [_vm._v("Mac an lighiche,")]), _vm._v(" ‘son of the "), _c('em', [_vm._v("líaigh")]), _vm._v(" or "), _c('em', [_vm._v("lighiche")]), _vm._v("’, and "), _c('em', [_vm._v("Mac an ollaimh")]), _vm._v(", ‘son of the "), _c('em', [_vm._v("ollamh")]), _vm._v("’. "), _c('em', [_vm._v("Leich")]), _vm._v(" needs no further explanation, nor does its Gaelic cognate "), _c('em', [_vm._v("líaigh")]), _vm._v(" or "), _c('em', [_vm._v("lighiche,")]), _vm._v(" but "), _c('em', [_vm._v("ollamh")]), _vm._v(", originally the highest grade of "), _c('em', [_vm._v("file")]), _vm._v(" or poet, came to mean a master in any profession or craft."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "rfn5"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" Thus, for instance, in Ireland "), _c('em', [_vm._v("ollamh legha Fermanach")]), _vm._v(" means ‘master in medicine of Fermanagh’. However, in Scotland by the middle of the sixteenth century at least and certainly in the context of a surname, "), _c('em', [_vm._v("ollamh")]), _vm._v(" had become associated particularly with medicine, so that "), _c('em', [_vm._v("Mac an ollaimh")]), _vm._v(" normally meant ‘son of the physician’. The titles "), _c('em', [_vm._v("an t-Ollamh Ileach")]), _vm._v(" (the "), _c('em', [_vm._v("ollamh")]), _vm._v(" of Islay) and "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(" (the "), _c('em', [_vm._v("ollamh")]), _vm._v(" of Mull), held by members of this kindred in the sixteenth and seventeenth centuries, were understood to refer to medical men without any explanation being deemed necessary. The crown rental of Islay in 1541 records the contemporary holder of the title "), _c('em', [_vm._v("an t-Ollamh Ileach")]), _vm._v(" as Fergus "), _c('em', [_vm._v("Ollamh")]), _vm._v(" without further qualification. Likewise the office held by "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(" was described in 1572 as "), _c('em', [_vm._v("ard-ollamhnachd.")]), _vm._v(" It was obviously understood that the skill required to hold the office was that of medicine, not of any other profession or craft."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn6",
      "id": "rfn6"
    }
  }, [_c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sometime in the second half of the sixteenth century the kindred began to adopt "), _c('em', [_vm._v("Beaton")]), _vm._v(" as a surname for use in non-Gaelic contexts. The first example on record of its adoption by a member of the kindred may be “Allister Mc Maister alias Betoun” who was acting “in name and behalf of the laird of Glengarrye” in 1585."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn7",
      "id": "rfn7"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" Alasdair Beaton, whose ancestor, judging by the alternative surname "), _c('em', [_vm._v("MacMaister")]), _vm._v(" or "), _c('em', [_vm._v("Mac a’ Mhaighstir,")]), _vm._v(" literally ‘son of the "), _c('em', [_vm._v("magister’,")]), _vm._v(" was a university graduate in Arts, was presumably a servitor of MacDonald of Glengarry. He was probably the same as “Alestar Betoun”, tacksman of the parsonage of Lochalsh, who signed a contract written in Scots on 3 September 1586 as “Alexander Betoun”."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn8",
      "id": "rfn8"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" Alasdair’s family cannot be identified with certainty"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn9",
      "id": "rfn9"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" but there can be no doubt of the affiliations of the second MacBeth on record to use "), _c('em', [_vm._v("Beaton")]), _vm._v(" as a surname. This was Malcolm of Pennycross in Mull who was "), _c('em', [_vm._v("an t-Ollamh Muileach")]), _vm._v(" from 1582 to 1603 at least."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn10",
      "id": "rfn10"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" In 1587 he wrote his name in Gaelic as "), _c('em', [_vm._v("Giolla-Coluim MacBhethadh")]), _vm._v(" and in Latin as "), _c('em', [_vm._v("Makcolmus MakBeath")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn11",
      "id": "rfn11"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" Somewhat later presumably, he again wrote his name as before in Gaelic but in Latin this time as "), _c('em', [_vm._v("Malcolmus Betune")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn12",
      "id": "rfn12"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("It is clear that it was in the person of Malcolm MacBeth that the Pennycross family began to adopt the surname "), _c('em', [_vm._v("Beaton")]), _vm._v(". Other families followed suit at irregular intervals. John MacBeth of Ballenabe in Islay was still using the Scoticised form of his Gaelic surname in a non-Gaelic context in 1629 but by 1643 he was apparently calling himself John "), _c('em', [_vm._v("Beatoun")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn13",
      "id": "rfn13"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" Thereafter all the surviving recorded medical families of the kindred, with one exception,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn14",
      "id": "rfn14"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" invariably used the surname "), _c('em', [_vm._v("Beaton")]), _vm._v(" in Latin, Scots and later English contexts. Eventually it was also given a Gaelic dress largely replacing the original surname in Gaelic. This process may have begun by the end of the seventeenth century. The result is that they are today generally known in Gaelic or English respectively as "), _c('em', [_vm._v("Peutanaich")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn15",
      "id": "rfn15"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" or "), _c('em', [_vm._v("Beatons")]), _vm._v(" and it will be convenient to refer to them by the latter form hereafter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, the original surname of the kindred is not forgotten by Gaelic speakers and there are, of course, people in Scotland today who continue to use one or other of the surviving Scoticised versions thereof. Leaving aside those who may have come over recently from Ireland where "), _c('em', [_vm._v("Beaton")]), _vm._v(" was never adopted, most present-day bearers of the Gaelic surname in Scotland may be descendants of families who ceased to practise medicine sometime before its replacement by "), _c('em', [_vm._v("Beaton")]), _vm._v(". In the process they would fall outwith the close-knit Gaelic professional orders, thereby losing immediate contact with new cultural developments in which their professional kinsmen were taking an interest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Beaton")]), _vm._v(", which derives ultimately from "), _c('em', [_vm._v("de Bethune")]), _vm._v(", was already the surname of a well-known kindred, mainly located in Fife and Angus, whose ancestor had come to Scotland sometime in the thirteenth century from Bethune in French Flanders."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn16",
      "id": "rfn16"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" In the second half of the sixteenth century they sometimes reverted to the French spelling of their surname. They were probably stimulated to do this by the fact of their close connections with France at this time, both in terms of their continuing support for Mary, Queen of Scots, and in the person of James Beaton, Archbishop of Glasgow, who, having gone to France at the time of the Reformation, remained there for much of the rest of his long life until his death in 1603."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn17",
      "id": "rfn17"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" It is not without interest that in 1599 he was James VI’s "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("ambassador to the King of France at the same time as Philippe de Bethune was French ambassador to the Scottish court."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn18",
      "id": "rfn18"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" Many of James Beaton’s kinsmen accompanied him to, or visited him in, France and one of the first to use the French spelling of their surname was his brother, Mr or Monsieur Bethune, who was Master of Queen Mary’s household during her imprisonment in England."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn19",
      "id": "rfn19"
    }
  }, [_c('sup', [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is no need to postulate any kin connection between the MacBeth medical kindred and its counterpart in the Lowlands to explain the adoption by the former of the surname "), _c('em', [_vm._v("Beaton")]), _vm._v(". All the evidence suggests that there was none. Rather "), _c('em', [_vm._v("Beaton")]), _vm._v(" or its Latin form "), _c('em', [_vm._v("Betonus")]), _vm._v(", similar in written, although not in spoken terms, was a convenient substitute for "), _c('em', [_vm._v("MacBeatha")]), _vm._v(" or "), _c('em', [_vm._v("MacBethadh")]), _vm._v(" in non-Gaelic contexts and these were becoming more frequent as the pervasiveness of central government and the complexity of the economy steadily increased from the Reformation onwards. There are other examples of this phenomenon in Scotland, perhaps the most relevant being the adoption of the Lowland surname of "), _c('em', [_vm._v("Livingston")]), _vm._v(" by the kindred whose Gaelic surname was "), _c('em', [_vm._v("MacDhuinnshléibhe")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn20",
      "id": "rfn20"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" They too belonged to the learned orders of Gaelic Scotland and Ireland, particularly to the medical profession, the most famous family thereof providing hereditary physicians to the O’Donnells of Tyrconnell in Donegal in the fifteenth and sixteenth centuries."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn21",
      "id": "rfn21"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" They also practised medicine in Cowal in the sixteenth century at least,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn22",
      "id": "rfn22"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" although the family domiciled in Scotland about whom most is known was associated with the church on the island of Lismore as hereditary keepers of the "), _c('em', [_vm._v("Bachall Mór")]), _vm._v(" of St. Moluag."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn23",
      "id": "rfn23"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" According to the genealogical account of the kindred in Scotland written in 1743, the equation of these surnames had already been made by 1645,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn24",
      "id": "rfn24"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" in this instance suggested by no more than the aural "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("similarity of the syllables, ‘shléibh-’ of "), _c('em', [_vm._v("MacDhuinnshléibhe")]), _vm._v(", in which the ‘s’ is not sounded, and ‘liv-’ of "), _c('em', [_vm._v("Livingston")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn25",
      "id": "rfn25"
    }
  }, [_c('sup', [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By 1645 too the fact of having adopted "), _c('em', [_vm._v("Livingston")]), _vm._v(" as an alternative surname had promoted the impression that the two kindreds were connected by blood. Exactly the same thing happened in the case of the MacBeths and the Beatons. The MacBeths were aware of the French origins of their Lowland compatriots and two important documents written in the second half of the seventeenth century specifically deny their application to the medical kindred, which was by this time clearly felt to be implicit in their very acceptance of the surname "), _c('em', [_vm._v("Beaton")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn26",
      "id": "rfn26"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" In the event two families went further than the rest in demonstrating their belief in this spurious connection. Towards the end of the seventeenth century the Beatons of Culnaskea in Easter Ross sometimes wrote the French form of the surname. They were followed in this by the Beatons of Husabost in Skye, although not until about the middle of the following century when they began to use "), _c('em', [_vm._v("Bethune")]), _vm._v(" regularly, and, taking the process to its logical conclusion, produced a genealogical tract which derived them specifically but erroneously from an alleged member of the Beatons of Balfour in Fife who was supposed to have flourished in the first half of the sixteenth century."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn27",
      "id": "rfn27"
    }
  }, [_c('sup', [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The medical Beatons fell naturally into two divisions, the one confined mainly to the Western Isles and the other to the mainland of Scotland, although the Beatons of Husabost, the branch of the latter division about whom most is known, were based in Skye. It is clear that the Beatons themselves recognised this twofold division, for each is most fully represented by a collection of genealogies and at no point do they seriously overlap. A further indication of their separate identity is that, at least until the end of the seventeenth century, certain characteristic forenames were confined to one or other, particularly "), _c('em', [_vm._v("Fergus, Gill-Anndrais")]), _vm._v(", and "), _c('em', [_vm._v("James")]), _vm._v(" to the first and to the second "), _c('em', [_vm._v("Fearchar, Angus")]), _vm._v(" and "), _c('em', [_vm._v("Gille-Pádruig.")]), _vm._v(" Characteristic Beaton forenames common to both divisions were "), _c('em', [_vm._v("Gille-Críost, Gille-Coluim")]), _vm._v(" and "), _c('em', [_vm._v("Neill.")]), _vm._v(" The island division is most fully represented by a collection of pedigrees entitled “Craobh-sgaoladh Chloinn Mheigbeathadh”, ‘The Branching-tree of the Clan Mac-beathadh’, in the Laing "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("MS III, 21,"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn28",
      "id": "rfn28"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" now in the Library of Edinburgh University, and the other by the genealogical tract already mentioned and published in 1778 under the title "), _c('em', [_vm._v("An Historical and Genealogical Account of the Bethunes of the Island of Sky")]), _vm._v(". Our study of the Beaton kindred will be most conveniently pursued by examining its two divisions in terms of these genealogical compilations.")]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }, [_c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v("      Steer and Bannerman, "), _c('em', [_vm._v("Monumental Sculpture")]), _vm._v(", p. 144.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v("      For other possible examples of a personal name associated with a profession or craft, see "), _c('em', [_vm._v("ibid")]), _vm._v("., p. 145; MacNeill, J., ‘Notes on Irish Ogham Inscriptions’, "), _c('em', [_vm._v("PRIA")]), _vm._v(", xxvii (1907–9), pp.365–6.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v("      Steer and Bannerman, "), _c('em', [_vm._v("Monumental Sculpture")]), _vm._v(", p. 144.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 29 for a possible late example of "), _c('em', [_vm._v("MacMeic-bethad")]), _vm._v(". The forms "), _c('em', [_vm._v("MacBeth")]), _vm._v(" and "), _c('em', [_vm._v("MacBeath")]), _vm._v(" derive from written Gaelic; "), _c('em', [_vm._v("MacVay, MacVia,")]), _vm._v(" and "), _c('em', [_vm._v("MacVeagh")]), _vm._v(" from spoken Gaelic, while "), _c('em', [_vm._v("MacBay")]), _vm._v(" and "), _c('em', [_vm._v("MacBey")]), _vm._v(" are hybrids, see Black, "), _c('em', [_vm._v("Surnames,")]), _vm._v(" pp. 457–8, 568. See also Jackson, K., "), _c('em', [_vm._v("The Gaelic Notes in the Book of Deer,")]), _vm._v(" 1972, p. 63. Finally, it should be noted that the quite different Gaelic surnames "), _c('em', [_vm._v("MacBeathain")]), _vm._v(" and "), _c('em', [_vm._v("MacBeathaig")]), _vm._v(" have been unnecessarily confused with "), _c('em', [_vm._v("MacBeth,")]), _vm._v(" even Scoticised as such on occasion, see Black, "), _c('em', [_vm._v("Surnames,")]), _vm._v(" pp. 457–8, 568; Dixon, J. R., "), _c('em', [_vm._v("Gairloch and Guide to Loch Maree,")]), _vm._v(" 1886, pp. 21–3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('em', [_vm._v("R.I.A. Dict")]), _vm._v("., O, pp. 138–9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 84.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")]), _vm._v("      Mackay, W. and Boyd, H. C, "), _c('em', [_vm._v("Records of Inverness")]), _vm._v(", New Spalding Club, i(1911), p. 299.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v("      Reg. Deeds, RD 1/26, f.20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 78.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 26–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")]), _vm._v("    Laing MS III 21, f.85r.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v("    Adv. 72. 1. 2. (MS II), f.65v.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 15–16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 30–1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")]), _vm._v("    Barrow, G.W.S., "), _c('em', [_vm._v("The Anglo-Norman Era in Scottish History")]), _vm._v(", 1980, pp. 22–3; Black, "), _c('em', [_vm._v("Surnames")]), _vm._v(", p. 72; see also "), _c('em', [_vm._v("Gen. Coll")]), _vm._v("., i, p. 4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17",
      "id": "fn17"
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('em', [_vm._v("CSP Scot")]), _vm._v("., "), _c('em', [_vm._v("passim")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., xiii (1597–1603), pp. 78, 467–74, 497 etc.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19",
      "id": "fn19"
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('em', [_vm._v("Ibid")]), _vm._v("., ii (1563–9), pp. 617, 696; vi (1581–3), pp. 109, 149. But as early as 30 June 1563, Mary Beaton, Queen Mary’s Lady-in-Waiting, was signing her name “Marie de Bethune” ("), _c('em', [_vm._v("ibid")]), _vm._v("., ii (1563–9), p. 17).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20",
      "id": "fn20"
    }
  }, [_vm._v("20")]), _vm._v("    ‘An Account of the Name of McLea’, "), _c('em', [_vm._v("HP")]), _vm._v(", iv, pp. 93–104; this tract was written by Mr. Duncan McLea, minister of Dull, on 3 January 1743. See also Black, "), _c('em', [_vm._v("Surnames")]), _vm._v(", pp. 432–3; Woulfe, "), _c('em', [_vm._v("Sloinnte")]), _vm._v(", pp. 355–6; Matheson, W., ‘Traditions of the MacKenzies’, "), _c('em', [_vm._v("TGSI")]), _vm._v(", xxxix–xl (1942–50), p. 203.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21",
      "id": "fn21"
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 27–8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22",
      "id": "fn22"
    }
  }, [_vm._v("22")]), _vm._v("    ‘An Account of the Name of McLea’, "), _c('em', [_vm._v("HP")]), _vm._v(", iv, p. 95.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23",
      "id": "fn23"
    }
  }, [_vm._v("23")]), _vm._v("    AT, 9 April, 19 May 1545; ‘An Account of the Name of MacLea’, "), _c('em', [_vm._v("HP")]), _vm._v(", iv, p. 96; "), _c('em', [_vm._v("OPS")]), _vm._v(", ii, pt. 1, p. 163.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24",
      "id": "fn24"
    }
  }, [_vm._v("24")]), _vm._v("    ‘An Account of the Name of McLea’, "), _c('em', [_vm._v("HP")]), _vm._v(", iv, pp. 96–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25",
      "id": "fn25"
    }
  }, [_vm._v("25")]), _vm._v("    The custom of providing Gaelic surnames with non-Gaelic equivalents may only have begun in the second half of the sixteenth century but long before this it was normal for Gaelic personal names to have acquired equivalents in Latin. As early as the first half of the fourteenth century, for example, Bricius was doing duty for Gaelic "), _c('em', [_vm._v("Gille-Brigde")]), _vm._v(" in Latin contexts. The letters ‘bri’ in each were sufficient to suggest the equation (Steer and Bannerman, "), _c('em', [_vm._v("Monumental Sculpture")]), _vm._v(", pp. 101, 103–4).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26",
      "id": "fn26"
    }
  }, [_vm._v("26")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", p. 18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27",
      "id": "fn27"
    }
  }, [_vm._v("27")]), _vm._v(" "), _c('em', [_vm._v("Infra")]), _vm._v(", pp. 55–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28",
      "id": "fn28"
    }
  }, [_vm._v("28")]), _vm._v("    Fos. 102v–103r. Facsimile between pp. 142 and 143 in MacKinnon, D., ‘The Genealogy of the MacBeths or Beatons of Islay and Mull’, "), _c('em', [_vm._v("CMJ")]), _vm._v(", v (1902–04).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45a79aea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 75
// module chunks = 0